import sessionService from 'web-client/utils/session'
import Api from 'web-client/utils/api'

/**
 * The new logout function is an _interface_,
 * the implementation of which we don't about.
 */

sessionService.inject('setBearerToken', (token) => Api.setBearerToken(token as string))
